module.exports = __webpack_public_path__ + "static/media/logo.4cfa8de4.png";